import { createContext } from 'react';

const WishListContext = createContext();

export const { Provider, Consumer } = WishListContext;

export default WishListContext;
